import {
  StyleBannerWrapper,
  StyleLeftBannerWrapper,
  StyleRightBannerWrapper,
} from './style'
import Typography from '@components/typography'
import Image from '@components/image'
import BannerImg from './banner.png'
import Button from '@components/button'
import Svg from '@components/svg'
import { useSelector } from 'react-redux'
import { store, Actions } from '@store'
import { useNavigate } from 'react-router-dom'
import NextInstantAppointment from '@commons/cards/nextInstantAppointment'
const Banner = () => {
  const navigate = useNavigate()
  const { data: appointmentConsultDashboard } = useSelector(
    (state: any) => state.appointmentConsultDashboard,
  )
  const { data: user } = useSelector((state: any) => state.user)
  const bannerInfo = {
    title: 'No Active Appointments',
    description: !!user?.queue
      ? `Queue Not Found`
      : `${appointmentConsultDashboard?.totalInstantRequest} Instant Consultation Request`,
    buttonTitle: !!user?.infos?.queue
      ? 'View Request List'
      : 'Create New Queue',
    type: !!user?.infos?.queue ? 'request' : 'create',
  }
  const handleClick = (event) => {
    const type = event.target.getAttribute('data-type')
    switch (type) {
      case 'create':
        store.dispatch(
          Actions.set('modal', {
            visible: true,
            type: 'queue',
          }),
        )
        break
      case 'request':
        navigate('/doctor/appointments/instants?tab=requests')
        break
    }
  }

  return (
    <>
      {!!appointmentConsultDashboard?.nextInstantAppointment ? (
        <NextInstantAppointment />
      ) : (
        <StyleBannerWrapper>
          <StyleLeftBannerWrapper>
            <Typography content={bannerInfo?.title} tc="primary" size={18} />
            <Typography content={bannerInfo?.description} tc="text" size={14} />
            <Button
              title={bannerInfo?.buttonTitle}
              rightComponent={<Svg svg="queue" color={'white'} />}
              height={40}
              data-type={bannerInfo?.type}
              onClick={handleClick}
            />
          </StyleLeftBannerWrapper>
          <StyleRightBannerWrapper>
            <Image src={BannerImg} height={300} />
          </StyleRightBannerWrapper>
        </StyleBannerWrapper>
      )}
    </>
  )
}
export default Banner
